import React from 'react';

/**
 * Fading lines showing hidden connections in focus mode
 */
export function HiddenConnectionLines({ tasks, positions, nodeDimensions, hiddenConnections }) {
  return (
    <>
      {tasks.map(task => {
        const pos = positions[task.id];
        const dims = nodeDimensions[task.id] || { width: 290, height: 150 };
        const hidden = hiddenConnections[task.id];
        // Skip if no position, no hidden connections, or invalid position values
        if (!pos || !hidden || !Number.isFinite(pos.x) || !Number.isFinite(pos.y)) return null;
        
        const centerX = pos.x + dims.width / 2;
        
        return (
          <g key={`hidden-${task.id}`}>
            {/* Fading line above (hidden upstream connections) */}
            {hidden.above && (
              <line
                x1={centerX}
                y1={pos.y}
                x2={centerX}
                y2={pos.y - 60}
                stroke="url(#fadeUp)"
                strokeWidth="2"
                strokeDasharray="4 4"
                className="flowchart__hidden-connection"
              />
            )}
            {/* Fading line below (hidden downstream connections) */}
            {hidden.below && (
              <line
                x1={centerX}
                y1={pos.y + dims.height}
                x2={centerX}
                y2={pos.y + dims.height + 60}
                stroke="url(#fadeDown)"
                strokeWidth="2"
                strokeDasharray="4 4"
                className="flowchart__hidden-connection"
              />
            )}
          </g>
        );
      })}
    </>
  );
}

/**
 * SVG gradient definitions for fading connection lines
 */
export function FadeGradientDefs() {
  return (
    <defs>
      <linearGradient id="fadeUp" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="rgba(100, 150, 255, 0.6)" />
        <stop offset="100%" stopColor="rgba(100, 150, 255, 0)" />
      </linearGradient>
      <linearGradient id="fadeDown" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="rgba(100, 150, 255, 0.6)" />
        <stop offset="100%" stopColor="rgba(100, 150, 255, 0)" />
      </linearGradient>
    </defs>
  );
}

export default HiddenConnectionLines;

